var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.588 5.419C8.377 4.2 6.515 4.183 5.353 5.43c-1.13 1.212-1.147 3.186.006 4.352l4.646 4.954.365-.4a143.2 143.2 0 0 1 2.133-2.274l.002-.002c.717-.754 1.438-1.512 2.144-2.287 1.128-1.212 1.144-3.184-.007-4.35a2.887 2.887 0 0 0-4.241.007L10 5.868l-.405-.442-.007-.007Z",
    fill: "currentColor"
  })));
};
export default SvgHeartFilled;